import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import Timeago from '../../../../../timeago'
import moment from 'moment'
import DatePicker from '../../../../../date_picker'

class UpdateJobCandidateCommitmentPeriod extends React.Component {

  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this)
  }

  onChange = (value) => {
    if (value == 'now') {
      value = moment().format("YYYY-MM-DD")
    }

    this.props.onChange(value)
  }

  render() {

    const moments = [
      {value: moment().add(1, 'months').format("YYYY-MM-DD"), name: moment().add(1, 'months').format("DD MMM")},
      {value: moment().add(3, 'months').format("YYYY-MM-DD"), name: moment().add(3, 'months').format("DD MMM")},
      {value: moment().add(6, 'months').format("YYYY-MM-DD"), name: moment().add(6, 'months').format("DD MMM")},
      {value: moment().add(12, 'months').format("YYYY-MM-DD"), name: moment().add(12, 'months').format("DD MMM YYYY")}
    ]

    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm">
            {this.props.commitment_period ?
              <span className="p-1 font-semibold"><Timeago date={this.props.commitment_period}/></span>
            :
              <span className="p-1 font-semibold">Select</span>
            }
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-auto">
          <div className="mb-4 text-sm font-medium">
            Tutor Commitment Period
          </div>
          <hr className="mb-4 border-border"/>
          <div className="flex flex-nowrap gap-4">
            <DatePicker
              onChange={this.onChange}
              value={this.props.commitment_period}
            />
            <div className="grid content-start gap-1">
              {_.map(moments, (time) => {
                return (
                  <Button key={time.value} variant="outline" size="sm" className="w-full" onClick={() => this.onChange(time.value)}>{time.name}</Button>
                )
              })}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    )
  }
}

export default UpdateJobCandidateCommitmentPeriod
